import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import AuthUtility from "../../util/AuthUtility";
import { Col, Button, Row, Container, Card, Form, InputGroup, Table, Pagination, Badge, DropdownButton, Dropdown } from 'react-bootstrap';
import SearchIcon from '@mui/icons-material/Search';
import InfoIcon from '@mui/icons-material/Info';
import { Page } from "../../dto/page/Page";
import toast, { Toaster } from 'react-hot-toast';
import { ListingListEntity } from "../../dto/listing/ListingListEntity";
import { ListingEntity } from "../../dto/listing/ListingEntity";
import { ListingSearch } from "../../dto/listing/ListingSearch";
import { onListingSearch } from "../../controller/ListingController";
import Select from 'react-select';
import { onBrandList, onCategoryList } from "../../controller/CategoryController";
import { BrandEntity } from "../../dto/brand/BrandEntity";
import { CategoryEntity } from "../../dto/category/CategoryEntity";
import { getAuctionEndedReasonBadge, getAuctionPermissionBadge, getAuctionStatusBadge, getAuctionTypeBadge } from "../../app/AppConst";
import { downloadDeliveryReceipt, downloadInvoice, downloadPaymentReceipt } from "../../controller/InvoiceController";

const ListingList = () => {
    const navigate = useNavigate();

    useEffect(() => {
        if (!AuthUtility.isUserLoggedIn()) {
            navigate("/login");
            window.location.reload();
        } else {
            categoryListGet(); // categories list get into select option
            brandListGet(); // brands list get into select option
        }
    }, []);

    const categoryListGet = async () => {
        const response = await onCategoryList();
        const cats: Array<CategoryEntity> = response.data.beans;
        const optionArray: Array<Object> = [];
        cats.map((item, index) => {
            var obj = {
                value: item.id + "",
                label: item.name
            }
            optionArray.push(obj);
        })
        setCategoryOptions(optionArray);
    }

    const brandListGet = async () => {
        const response = await onBrandList();
        const brands: Array<BrandEntity> = response.data.beans;
        const optionArray: Array<Object> = [];
        brands.map((item, index) => {
            var obj = {
                value: item.id + "",
                label: item.name
            }
            optionArray.push(obj);
        })
        setBrandOptions(optionArray);
    }

    // USER LIST
    const [listing, setListing] = useState<ListingListEntity>({
        page: undefined,
        data: []
    });

    const [search, setSearch] = useState<ListingSearch>({
        offset: -1,
        limit: 10
    });

    const [categoryOptions, setCategoryOptions] = useState<Array<Object>>([]);
    const [brandOptions, setBrandOptions] = useState<Array<Object>>([]);

    // ---- Search submit
    const searchSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        load(0); // reset to first page on new search
    };

    // ---- Pagination click
    const changePage = (page: number) => {
        if (!listing.page) return;
        if (page < 0 || page >= listing.page.totalPages) return;
        load(page);
    };

    const load = async (page: number = 0) => {
        const params: ListingSearch = {
            ...search,
            offset: page
        };

        const response = await onListingSearch(params);

        if (response.status !== 0) {
            toast.error("Дуудлага худалдаа уншихад алдаа гарлаа");
            return;
        }

        const pageable = response.data;

        const pageInfo: Page = {
            limit: search.limit,
            totalElements: pageable.totalElements,
            totalPages: pageable.totalPages,
            offset: page
        };

        const beans: Array<ListingEntity> = pageable.beans;

        setListing({
            page: pageInfo,
            data: beans
        });

        setSearch(prev => ({ ...prev, offset: page }));
    };

    const categoryIdsHandler = (value: Object) => {
        var ids: Array<number> = Array.isArray(value) ? value.map(x => parseInt(x.value)) : [];
        setSearch({
            ...search,
            categoryIds: ids
        })
    }

    const brandIdsHandler = (value: Object) => {
        var ids: Array<number> = Array.isArray(value) ? value.map(x => parseInt(x.value)) : [];
        setSearch({
            ...search,
            brandIds: ids
        })
    }

    const onInvoice = async (id: number) => {
        try {
            await downloadInvoice(id);
        } catch {
            toast.error("Нэхэмжлэл татахад алдаа гарлаа");
        }
    };

    const onDeliveryInvoice = async (id: number) => {
        try {
            await downloadDeliveryReceipt(id);
        } catch {
            toast.error("Хүргэлтийн баримт татахад алдаа гарлаа");
        }
    };

    const onPaymentInvoice = async (id: number) => {
        try {
            await downloadPaymentReceipt(id);
        } catch {
            toast.error("Төлбөрийн баримт татахад алдаа гарлаа");
        }
    };

    return (
        <div>
            <Container fluid>
                <h3><a onClick={() => navigate(-1)}><big>&#8592;</big></a>Дуудлага худалдаа</h3>
                <Row className="d-flex justify-content-center align-items-center">
                    <Col md={12} lg={12} xs={12}>
                        <Card>
                            <Card.Header>
                                <Form onSubmit={searchSubmit}>
                                    <Row>
                                        <Col md={3}>
                                            <Form.Group className="mb-3" controlId="name">
                                                <Form.Label className="text-center">Nickname</Form.Label>
                                                <Form.Control size="sm" type="text" 
                                                onChange={(event) => {
                                                    const value = event.target.value;
                                                    if (value !== "") {
                                                        setSearch({
                                                            ...search,
                                                            nickname: event.target.value
                                                        })
                                                    } else {
                                                        const { nickname, ...rest } = search;
                                                        setSearch(rest);
                                                    }
                                                }} />
                                            </Form.Group>
                                        </Col>
                                        <Col md={3}>
                                            <Form.Group className="mb-3" controlId="phoneNo">
                                                <Form.Label className="text-center">
                                                    User Phone
                                                </Form.Label>
                                                <Form.Control size="sm" type="text" 
                                                onChange={(event) => {
                                                    const value = event.target.value;
                                                    if (value !== "") {
                                                        setSearch({
                                                            ...search,
                                                            phoneNo: event.target.value
                                                        })
                                                    } else {
                                                        const { phoneNo, ...rest } = search;
                                                        setSearch(rest);
                                                    }
                                                }} />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={3}>
                                            <Form.Group className="mb-3" controlId="name">
                                                <Form.Label className="text-center">Category</Form.Label>
                                                <Select
                                                options={categoryOptions}
                                                onChange={categoryIdsHandler}
                                                isMulti={true}
                                                isClearable={true}
                                                isSearchable={true}
                                                isDisabled={false}
                                                isLoading={false}
                                                isRtl={false}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={3}>
                                            <Form.Group className="mb-3" controlId="name">
                                                <Form.Label className="text-center">Brand</Form.Label>
                                                <Select
                                                options={brandOptions}
                                                onChange={brandIdsHandler}
                                                isMulti={true}
                                                isClearable={true}
                                                isSearchable={true}
                                                isDisabled={false}
                                                isLoading={false}
                                                isRtl={false}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={3}>
                                            <Form.Group className="mb-3" controlId="limit">
                                                <Form.Label>Багцлах</Form.Label>
                                                <InputGroup className="mb-3">
                                                    <Form.Select size="sm" 
                                                    onChange={(event) => setSearch({
                                                        ...search,
                                                        limit: parseInt(event.target.value)
                                                    })}>
                                                        <option value="10">10</option>
                                                        <option value="25">25</option>
                                                        <option value="0">Бүгд</option>
                                                    </Form.Select>
                                                    <Button size="sm" type="submit">
                                                        <SearchIcon fontSize="small"/>
                                                    </Button>
                                                </InputGroup>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Form>
                            </Card.Header>
                            <Card.Body>
                                <div className="table-responsive">
                                    <Table hover>
                                        <thead>
                                            <tr>
                                                <th>Auction</th>
                                                <th>Created At</th>
                                                <th>Duration</th>
                                                <th>Product</th>
                                                <th>User Phone</th>
                                                <th>Type</th>
                                                <th>Status</th>
                                                <th>Permission</th>
                                                <th>Start Price</th>
                                                <th>Buy Price</th>
                                                <th>Fee</th>
                                                <th>Currency</th>
                                                <th>Cancelled</th>
                                                <th>Ended At</th>
                                                <th>Ended Reason</th>
                                                <th>Documents</th>
                                                <th><InfoIcon /></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {listing.data?.length === 0 && (
                                                <tr>
                                                    <td className="text-muted">
                                                        Илэрц олдсонгүй
                                                    </td>
                                                </tr>
                                            )}

                                            {
                                                listing.data?.map((data, dataIdx) => {
                                                    return (
                                                        <tr key={dataIdx}>
                                                            <td>{data.id}</td>
                                                            <td>{data.createdAt
                                                            ? new Date(data.createdAt).toLocaleString()
                                                            : "-"}</td>
                                                            <td>
                                                            {data.startsAt
                                                            ? new Date(data.startsAt).toLocaleString()
                                                            : "-"} - {data.endsAt
                                                            ? new Date(data.endsAt).toLocaleString()
                                                            : "-"} </td>
                                                            <td>{data.productTitle}</td>
                                                            <td>{data.accountPhoneNo}</td>
                                                            <td>
                                                                <Badge bg={getAuctionTypeBadge(data.type)}>{data.type}</Badge>
                                                            </td>
                                                            <td>
                                                                <Badge bg={getAuctionStatusBadge(data.status)}>{data.status}</Badge>
                                                            </td>
                                                            <td>
                                                                <Badge bg={getAuctionPermissionBadge(data.permission)}>{data.permission}</Badge>
                                                            </td>
                                                            <td>{data.startPrice}</td>
                                                            <td>{data.buyNowPrice}</td>
                                                            <td>{data.listingFeeAmount}</td>
                                                            <td>{data.listingFeeCurrency}</td>
                                                            <td>{data.cancelledAt
                                                            ? new Date(data.cancelledAt).toLocaleString()
                                                            : "-"}</td>
                                                            <td>{data.endedAt
                                                            ? new Date(data.endedAt).toLocaleString() + ", " + data.endedReason
                                                            : "-"}</td>
                                                            <td>
                                                                <Badge bg={getAuctionEndedReasonBadge(data.endedReason)}>{data.endedReason}</Badge>
                                                            </td>
                                                            <td>
                                                                {data.purchaseOrderId ? (
                                                                    <DropdownButton
                                                                        size="sm"
                                                                        variant="outline-primary"
                                                                        title="PDF"
                                                                        align="end"
                                                                        id={`pdf-dropdown-${data.id}`}
                                                                    >
                                                                        <Dropdown.Item onClick={() => data.id && onInvoice(data.id)}>
                                                                            Нэхэмжлэл
                                                                        </Dropdown.Item>
                                                                        <Dropdown.Item onClick={() => data.id && onDeliveryInvoice(data.id)}>
                                                                            Хүргэлтийн баримт
                                                                        </Dropdown.Item>
                                                                        <Dropdown.Item onClick={() => data.id && onPaymentInvoice(data.id)}>
                                                                            Төлбөрийн баримт
                                                                        </Dropdown.Item>
                                                                    </DropdownButton>
                                                                ) : (
                                                                    <span className="text-muted">—</span>
                                                                )}
                                                            </td>
                                                            <td><a href={`/listing/${data.id}`}><InfoIcon /></a></td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </Table>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>  
                </Row>

                {listing.page && listing.page.totalPages > 1 && (() => {
                const page = listing.page;   // now TypeScript knows it's NOT undefined

                return (
                    <Row>
                        <Col className="d-flex justify-content-start">
                            <Pagination>
                                <Pagination.First
                                    disabled={page.offset === 0}
                                    onClick={() => changePage(0)}
                                />

                                <Pagination.Prev
                                    disabled={page.offset === 0}
                                    onClick={() => changePage(page.offset - 1)}
                                />

                                {Array.from({ length: page.totalPages })
                                    .slice(
                                        Math.max(page.offset - 2, 0),
                                        Math.min(page.offset + 3, page.totalPages)
                                    )
                                    .map((_, idx) => {
                                        const pageNumber =
                                            Math.max(page.offset - 2, 0) + idx;

                                        return (
                                            <Pagination.Item
                                                key={pageNumber}
                                                active={pageNumber === page.offset}
                                                onClick={() => changePage(pageNumber)}
                                            >
                                                {pageNumber + 1}
                                            </Pagination.Item>
                                        );
                                    })}

                                <Pagination.Next
                                    disabled={page.offset + 1 >= page.totalPages}
                                    onClick={() => changePage(page.offset + 1)}
                                />

                                <Pagination.Last
                                    disabled={page.offset + 1 >= page.totalPages}
                                    onClick={() => changePage(page.totalPages - 1)}
                                />
                            </Pagination>
                        </Col>
                    </Row>
                );
            })()}
            </Container>
        </div>
    )
}

export default ListingList;